import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AbacusComp  from "./Component/AbacusComp"

const Abacus =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AbacusComp />
        </div>
        <Footer />
        </>
    )
}

export default Abacus